import { request } from '@utils';

export const getCompetitionVehicles = async (params = {}) => {
  const results = await request.get(
    `/charlotte/search?${new URLSearchParams(params)}`
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};
